import { linkToClassStudentsPage } from "../../links";

export function linkToManageStudentsPage(classId?: string) {
  return `${linkToClassStudentsPage(classId)}/manage`;
}
